export default __webpack_public_path__ + "static/media/vr-illustration.36f9c7ec.svg";